module.exports = __webpack_public_path__ + "img/icon-nav-link.f3fe2dba.svg";